import { httpApi } from 'core/httpApi';

export const buyTwistByHash = async (hash: string, signal?: AbortSignal) =>
    httpApi.v2.post('billing/buy', { hash }, { signal });
